<section class="favorite-tracks-screen" data-cy="favorite-tracks-screen">

  <!-- Tabs -->
  <div class="fav-tabs tw-flex tw-mb-[20px]">
    <button
      type="button"
      class="fav-tab tw-flex-1"
      [class.active]="activeTab === 'unselected'"
      (click)="selectTab('unselected')"
      data-cy="unselected-tracks"
    >
      {{ 'account.preferences.favoritetracks.unselected' | translate: 'Unselected Tracks' }}
    </button>
    <button
      type="button"
      class="fav-tab tw-flex-1"
      [class.active]="activeTab === 'favorite'"
      (click)="selectTab('favorite')"
      data-cy="favorite-track-list"
    >
      {{ 'account.preferences.favoritetracks.favoritelist' | translate: 'Favorite Track List' }}
    </button>
  </div>

  <!-- Unselected tracks -->
  <div *ngIf="activeTab === 'unselected'">
    <div class="fav-actions tw-flex tw-items-center tw-gap-[8px] tw-mb-[16px]">
      <input
        (input)="onSearch($event, false)"
        type="text"
        placeholder="{{ 'STABLE_SYSTEM.TRACKNAME' | translate: 'Track Name' }}"
        class="fav-search tw-flex-1"
        data-cy="track-name"
      >
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="addEvent()"
        [disabled]="!selectedEvents.length || isProcessing"
        data-cy="fav-add-btn"
      >
        {{ 'generic.add' | translate: '+ Add' }}
      </button>
      <button
        mat-icon-button
        type="button"
        (click)="refreshSelected()"
        attr.aria-label="{{ 'ui.account.reset.selection' | translate: 'Reset selection' }}"
        data-cy="reset-btn"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <div class="fav-list">
      <div
        *ngFor="let item of untrackedEvents"
        class="event-row"
        (click)="toggleSelect(item.EventId)"
      >
        <mat-checkbox
          color="primary"
          [checked]="isSelected(item.EventId)"
          (change)="toggleSelect(item.EventId)"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
        <span class="event-name">{{ item.EventName }}</span>
      </div>

      <p *ngIf="!untrackedEvents.length" class="fav-empty" data-cy="unselected-empty">
        {{ 'ui.account.no.tracks.available' | translate: 'No tracks available.' }}
      </p>
    </div>
  </div>

  <!-- Favorite tracks -->
  <div *ngIf="activeTab === 'favorite'">
    <div class="fav-actions tw-flex tw-items-center tw-gap-[8px] tw-mb-[16px]">
      <input
        (input)="onSearch($event, true)"
        type="text"
        placeholder="{{ 'STABLE_SYSTEM.TRACKNAME' | translate: 'Track Name' }}"
        class="fav-search tw-flex-1"
      >
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="clearFavoriteEvents()"
        [disabled]="!listOfFavorites.length || isProcessing"
        data-cy="fav-clear-btn"
      >
        {{ 'generic.clear.all' | translate: 'Clear All' }}
      </button>
    </div>

    <div class="fav-list">
      <div *ngFor="let item of favoriteEvents" class="event-row">
        <span class="event-name tw-flex-1">{{ item.EventName }}</span>
        <button
          mat-icon-button
          type="button"
          (click)="removeEvent($event, item.EventId)"
          attr.aria-label="{{ 'ui.account.remove.favorite' | translate: 'Remove favorite' }}"
        >
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>

      <p *ngIf="!favoriteEvents.length" class="fav-empty" data-cy="favorite-empty">
        {{ 'ui.account.no.favorite.tracks.yet' | translate: 'No favorite tracks yet.' }}
      </p>
    </div>
  </div>

</section>
